import { i18nextContainer } from 'shared/configs/i18n/config'
import { passwordSchema } from 'shared/schemas/password.schema'
import { z } from 'zod'

const passwordSchemaWithKey = z.string().superRefine((value, ctx) => {
  const result = passwordSchema.safeParse(value)
  if (!result.success) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: i18nextContainer.t('common:validation.password')
    })
  }
})

export const changePasswordSchema = z
  .object({
    currentPassword: z.string().min(1, {
      message: i18nextContainer.t(
        'auth:my_profile_page.change_password.validation.current_password_required'
      )
    }),
    newPassword: passwordSchemaWithKey,
    confirmNewPassword: z.string().min(1, {
      message: i18nextContainer.t(
        'auth:my_profile_page.change_password.validation.confirm_password_required'
      )
    })
  })
  .refine(data => data.newPassword === data.confirmNewPassword, {
    message: i18nextContainer.t(
      'auth:my_profile_page.change_password.validation.passwords_do_not_match'
    ),
    path: ['confirmNewPassword']
  })
  .refine(data => data.currentPassword !== data.newPassword, {
    message: i18nextContainer.t(
      'auth:my_profile_page.change_password.validation.new_password_same_as_current'
    ),
    path: ['newPassword']
  })
